<template>
  <woot-modal
    :show="show"
    :on-close="close"
  >
    <div class="p-6">
      <h2 class="text-xl font-bold mb-4">
        New Broadcast Campaign
      </h2>

      <label class="block mb-4">
        Campaign Name
        <input
          v-model="campaign.name"
          class="w-full border rounded p-2 mt-1"
        >
      </label>

      <label class="block mb-4">
        Template
        <input
          v-model="campaign.template"
          class="w-full border rounded p-2 mt-1"
        >
      </label>

      <div class="flex justify-end gap-2">
        <button
          class="px-4 py-2 border rounded"
          @click="close"
        >
          Cancel
        </button>

        <button
          class="px-4 py-2 bg-blue-600 text-white rounded"
          @click="save"
        >
          Create
        </button>
      </div>
    </div>
  </woot-modal>
</template>

<script setup>
import { reactive } from 'vue';

const props = defineProps({
  show: Boolean,
});

const emit = defineEmits([
  'close',
  'save',
]);

const campaign = reactive({
  name: '',
  template: '',
});

function close() {
  emit('close');
}

function save() {
  emit('save', { ...campaign });
}
</script>
